(function () {
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var chatOffset = -1;

  function findChatTargets() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return [];

    if (window.getComputedStyle(chat).position === 'fixed') return [chat];

    var targets = [];

    Array.prototype.forEach.call(chat.children, function (el) {
      if (window.getComputedStyle(el).position === 'fixed') targets.push(el);
    });

    if (chat.shadowRoot) {
      Array.prototype.forEach.call(chat.shadowRoot.querySelectorAll('*'), function (el) {
        if (window.getComputedStyle(el).position === 'fixed') targets.push(el);
      });
    }

    return targets;
  }

  function liftChat(offset) {
    if (offset === chatOffset) return;

    var targets = findChatTargets();
    if (!targets.length) return;

    chatOffset = offset;
    targets.forEach(function (el) {
      el.style.transition = 'translate 0.3s ease';
      el.style.translate = offset > 0 ? '0 -' + offset + 'px' : '';
    });
  }

  function initStickyAtc(bar) {
    if (bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    var form = document.getElementById(bar.dataset.formId);
    var section = document.getElementById(bar.dataset.sectionId);
    if (!form || !section) return;

    document.body.appendChild(bar);

    var mainButton = form.querySelector('[data-add-to-cart]');
    var mainLabel = form.querySelector('[data-add-to-cart-text]');
    var mainPrice = section.querySelector('[data-product-price]');
    var stickyButton = bar.querySelector('.sticky-atc__button');
    var stickyLabel = bar.querySelector('.sticky-atc__label');
    var stickyPrice = bar.querySelector('.sticky-atc__price');
    var selects = bar.querySelectorAll('.sticky-atc__select');
    var footer = null;

    var passedMain = false;
    var footerVisible = false;
    var clickedFromSticky = false;
    var successTimer = null;
    var safetyTimer = null;

    function updateVisibility() {
      var show = passedMain && !footerVisible;
      bar.classList.toggle('is-visible', show);

      if (show && mobileQuery.matches) {
        liftChat(bar.offsetHeight + 8);
      } else {
        liftChat(0);
      }
    }

    function checkMain() {
      if (!mainButton) return;
      passedMain = mainButton.getBoundingClientRect().bottom < 0;
    }

    function checkFooter() {
      if (!footer) footer = document.querySelector('.site-footer') || document.querySelector('footer');
      if (!footer) return;
      footerVisible = footer.getBoundingClientRect().top < window.innerHeight;
    }

    function onScroll() {
      checkMain();
      checkFooter();
      updateVisibility();
    }

    function optionSelect(position) {
      return section.querySelector('select[data-index="option' + position + '"]');
    }

    function optionRadios(position) {
      return section.querySelectorAll('input[type="radio"][data-index="option' + position + '"]');
    }

    function readOption(position) {
      var select = optionSelect(position);
      if (select) return select.value;
      var checked = Array.prototype.find.call(optionRadios(position), function (input) {
        return input.checked;
      });
      return checked ? checked.value : null;
    }

    function writeOption(position, value) {
      var select = optionSelect(position);
      if (select) {
        if (select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      var radio = Array.prototype.find.call(optionRadios(position), function (input) {
        return input.value === value;
      });
      if (radio && !radio.checked) radio.click();
    }

    function syncFromMain() {
      if (mainButton && !stickyButton.classList.contains('is-success') && !stickyButton.classList.contains('is-loading')) {
        if (mainLabel) stickyLabel.textContent = mainLabel.textContent.trim();
        stickyButton.disabled = mainButton.disabled;
      }

      if (mainPrice) stickyPrice.textContent = mainPrice.textContent.trim();

      selects.forEach(function (select) {
        var value = readOption(select.dataset.optionPosition);
        if (value !== null && select.value !== value) select.value = value;
      });
    }

    function finishLoading() {
      clearTimeout(safetyTimer);
      stickyButton.classList.remove('is-loading');
      clickedFromSticky = false;
    }

    function showSuccess() {
      clearTimeout(successTimer);
      stickyButton.classList.add('is-success');
      successTimer = setTimeout(function () {
        stickyButton.classList.remove('is-success');
        syncFromMain();
      }, 1800);
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled || !mainButton) return;
      clickedFromSticky = true;
      stickyButton.classList.remove('is-success');
      stickyButton.classList.add('is-loading');

      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(function () {
        finishLoading();
        syncFromMain();
      }, 8000);

      mainButton.click();
    });

    document.addEventListener('ajaxProduct:added', function () {
      if (!clickedFromSticky) return;
      finishLoading();
      showSuccess();
    });

    document.addEventListener('ajaxProduct:error', function () {
      if (!clickedFromSticky) return;
      finishLoading();
      syncFromMain();
    });

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        writeOption(select.dataset.optionPosition, select.value);
        setTimeout(syncFromMain, 300);
      });
    });

    section.addEventListener('change', function () {
      setTimeout(syncFromMain, 300);
    });

    if (mainButton) {
      new MutationObserver(syncFromMain).observe(mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
    }

    if (mainPrice) {
      new MutationObserver(syncFromMain).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      chatOffset = -1;
      onScroll();
    });

    syncFromMain();
    onScroll();
  }

  function initAll() {
    document.querySelectorAll('.sticky-atc').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();